// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"c07bfed4","296":"1de2a95d","346":"f5c8ef8a","637":"79e859b3"}[chunkId] + ".chunk.js";
};